import type { SettableLineApprovalState } from '@erp/rpc';
import type { AssignmentLine } from './useReplenishmentSuggestions';

/**
 * The lines with the buyer's approval state applied to the given suggestion
 * ids, as the server will derive it: a rejected or released line is never
 * touched (only pending lines are updated), and a credit-held line stays in Trouble whatever
 * the buyer sets. Returns the same array when nothing changes so a cache update
 * does not re-render subscribers for no reason.
 */
export function withApprovalState(
  lines: AssignmentLine[],
  suggestionIds: ReadonlySet<string>,
  state: SettableLineApprovalState,
): AssignmentLine[] {
  const troubleReason: AssignmentLine['troubleReason'] =
    state === 'trouble' ? 'manual' : null;
  let changed = false;
  const next = lines.map((line) => {
    if (
      !suggestionIds.has(line.suggestionId) ||
      line.approvalState === 'rejected' ||
      line.approvalState === 'released' ||
      line.troubleReason === 'credit_hold' ||
      (line.approvalState === state && line.troubleReason === troubleReason)
    ) {
      return line;
    }
    changed = true;
    return { ...line, approvalState: state, troubleReason };
  });
  return changed ? next : lines;
}
